import { NoteModel } from '../../../models/student-notes/note.model';
import { eponaQuery } from '@/helpers/graphql_modules/epona';
import { getNoteOriginUrlQuery } from '@/store/queries/pegasus-epona.queries';

export class NoteService {
  static async getUpdatedNoteOriginUrlByNote(note: NoteModel): Promise<string> {
    const { platform, originUrl, discipline, lesson, dexDiscipline, dexLesson } = note;

    const payload: any = {
      platform,
      originUrl,
      discipline: { id: discipline?.id.toString(), name: discipline?.name, slug: discipline?.slug },
      lesson: { id: lesson?.id.toString(), name: lesson?.name, slug: lesson?.slug },
    };

    if (dexDiscipline) {
      payload.dexDiscipline = {
        id: dexDiscipline.id,
        name: dexDiscipline.name,
        slug: dexDiscipline.slug,
      };
    }

    if (dexLesson) {
      payload.dexLesson = {
        id: dexLesson.id,
        name: dexLesson.name,
        slug: dexLesson.slug,
      };
    }

    const response = await eponaQuery(getNoteOriginUrlQuery, {
      note: {
        ...payload,
      },
    });

    const {
      data: { getNoteOriginUrl },
    } = response;

    return getNoteOriginUrl.data;
  }
}
